export type Locale = 'ar' | 'en'
export const LOCALES: Locale[] = ['ar', 'en']

/** Bilingual string. Every piece of public copy is authored in both languages. */
export type L10n = { ar: string; en: string }

export type Route = { locale: Locale; segments: string[]; path: string }

export function parse(pathname: string): Route {
  const parts = pathname.split('/').filter(Boolean)
  const first = parts[0] as Locale
  const locale: Locale = LOCALES.includes(first) ? first : 'en'
  const segments = LOCALES.includes(first) ? parts.slice(1) : parts
  return { locale, segments, path: '/' + segments.join('/') }
}

/** Translate a bilingual value directly given a locale. Safe on both server and client. */
export function t(v: L10n, locale: Locale) {
  return v[locale]
}

/** Build a localized href from a locale-neutral path like "/services/erp-crm". */
export function href(locale: Locale, path: string) {
  const clean = path === '/' ? '' : path.replace(/\/$/, '')
  return `/${locale}${clean}`
}
